import "./EndOfCampain.scss";
import guitarPinkCasette from '../../assets/guitarPinkCasette.png';
import Turntable from '../../assets/Turntable.png';
import Smiley from '../../assets/smiley.png'

import {
    Fragment,
    Dispatch,
    SetStateAction
} from 'react'

interface EndOfCampainProps {
    whereToNavigate?: string
    isMobile: boolean
    setShowBottomElements: Dispatch<SetStateAction<boolean>>
}


const EndOfCampain = ({
    isMobile = false,
}: EndOfCampainProps) => {

    return (
        <Fragment>
            {isMobile && (
                <>
                    <div className="body">
                        <div className="wrapper-premii">
                            <div className="container-inscrie-new">
                                <img src={Turntable} alt="turntable" className="check-container-turntable"/>
                                <h3 className="text-inscrie-new">
                                    Campania<br />
                                    s-a încheiat
                                </h3>
                                <div className="check-container-inscrie-new">
                                    <p className="checkbox-text-inscrie-new">
                                        Mulțumim<br />
                                        pentru participare!<br /><br />
                                        Vezi lista câștigătorilor <br /><u><a target="_blank"  href="https://heineken.com/media-eu/ee0e0ft3/castigatori-refresh-your-music-2024.pdf">aici</a></u>
                                    </p>
                                </div>
                                
                                <a className="button-ha" href="https://www.heineken.com/ro/ro/" target="_blank"  rel="noreferrer">Înapoi la site</a>
                                <div className="guitar-beers-casette">
                                    <img
                                        src={guitarPinkCasette}
                                        className="guitar-pink-casette"
                                        alt="guitar pink"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
            {!isMobile && (
                <>
                    <div className="horeca-home-container">                        
                        <div className="horeca-home-wrapper">
                            <p className="horeca-home-title">
                                <span>Campania s-a încheiat</span> <br />
                                Mulțumim pentru participare!<br /><br />
                                Vezi lista câștigătorilor <u><a target="_blank"  href="https://heineken.com/media-eu/ee0e0ft3/castigatori-refresh-your-music-2024.pdf">aici</a></u>
                            </p>
                            <a className="button-ha" href="https://www.heineken.com/ro/ro/" target="_blank"  rel="noreferrer">Înapoi la site</a>
                            <div className="disks"></div>
                        </div>
                        <div className="right-side-assets">
                            <img src={Turntable} alt="Turntable" className="turtable"/>
                            <img src={Smiley} alt="Smiley" className="smiley"/>
                            <div className="right-side-assets__kv-trade" />
                        </div>
                        <div className="left-side-assets"></div>
                    </div>
                    <div
                        className={`disclaimer-campanie disclaimer-campanie-horeca isDesktop`}
                    >
                        <p className="disclaimer-campanie-horeca-continut">
                            Campania „Heineken®️ Music” se desfășoară în perioada 01.07.2024 -
                            31.08.2024, pe întreg teritoriul României, în locaţiile
                            participante (conform Regulament). La achiziţia a oricăror 2
                            produse de bere Heineken Original®️, Heineken Silver®️, Heineken
                            0.0®️, în orice formă de ambalaj și în orice combinaţie, scanează
                            codul QR sau înscrie bonul fiscal pe site-ul
                            https://www.heineken.com/ro/promotii sau trimite un sms la numărul
                            *1841 (înscrierea trebuie să fie de forma: magazin data
                            (AAAA-LL-ZZ) număr bon, exemplu PROXY 2024-07-15 179) și intri
                            automat în tragerea la sorţi pentru unul din premiile campaniei.
                            Se acordă, prin tragere la sorţi, 8 x Experienţe VIP duble la
                            festivalul NOS Alive din 2025 (bilete acces, 4 nopţi de cazare,
                            transport și diurnă), în valoare individuală de 25.000 RON (TVA
                            inclus), 50 x Experienţe VIP la evenimentul Heineken Refresh your
                            Music (bilete acces, 2 nopţi de cazare, transport și diurnă), în
                            valoare individuală de 5.000 RON (TVA inclus) și 500 de frapiere
                            cu led și boxă, în valoare individuală de 145 RON (fără TVA).
                            Valoarea comercială totală a premiilor este de 522.500 RON. Pentru
                            mai multe detalii, consultă Regulamentul disponibil gratuit pe
                            www.heineken.com/ro/ro/regulamente sau la Infoline (021)5280673
                            (număr cu tarif normal). Imaginile premiilor acordate în campanie
                            sunt cu titlu de prezentare.
                        </p>
                    </div>
                </>
            )}
        </Fragment>
    );
};

export default EndOfCampain;
